module.exports = __webpack_public_path__ + "static/media/banner.a66ee976.png";